// Das Formular auf `/vorlagen/:slug/schnittbericht` zeigt nur die
// Einstellungen, die zum gewählten Gerät gehören.
//
// Ohne JavaScript stehen beide Gruppen da -- die Seite muss ohne auskommen,
// wie das Melden-Formular daneben, und der Server sagt dann, dass eine
// Laserleistung an einer Schneidemaschine nichts verloren hat. Mit
// JavaScript ist die Frage gar nicht erst zu stellen.
//
// Kein React: die Seite ist server-gerendert, und eine React-Wurzel für zwei
// `hidden`-Attribute wäre ein Bundle mehr. Dieselbe Bauart wie
// `characterCounter.ts`: eine reine Funktion, die entscheidet, und eine
// zweite, die das Ergebnis an die Seite hängt.

import { showsCutterSettings, showsLaserSettings, type DeviceKind } from '../editor/cutReport'

// Welche Gruppen sichtbar sind. `null` heißt „noch kein Gerät gewählt": dann
// stehen beide da, weil die Frage noch offen ist.
export function visibleSettingGroups(kind: DeviceKind | null): { cutter: boolean; laser: boolean } {
  return { cutter: showsCutterSettings(kind), laser: showsLaserSettings(kind) }
}

function kindOf(select: HTMLSelectElement): DeviceKind | null {
  const option = select.selectedOptions[0]
  const kind = option?.dataset.kind

  return kind === 'cutter' || kind === 'laser' || kind === 'other' ? kind : null
}

export function startDeviceSettings(root: ParentNode = document): void {
  const select = root.querySelector<HTMLSelectElement>('[data-device-select]')
  if (!select) return

  const groups = Array.from(root.querySelectorAll<HTMLFieldSetElement>('[data-settings-group]'))
  if (groups.length === 0) return

  const update = (): void => {
    const visible = visibleSettingGroups(kindOf(select))

    for (const group of groups) {
      const name = group.dataset.settingsGroup
      group.hidden = name === 'cutter' ? !visible.cutter : name === 'laser' ? !visible.laser : false
    }
  }

  select.addEventListener('change', update)
  update()
}
